import React from "react";

export const Scrolltop = () => {

    return (
        <div className="scroll-top">
            <span>Top<i className="bi bi-arrow-up"></i></span>
        </div>
    )
}